import {get} from '../request'

const news = {
    /**
     * 新闻详细信息获取 
     * @param id
     */ 
    getNewsDetail(id){
        return get(`/web/newsInfoEntity/getById?id=${id}`)
    },
    /**
     * 获取更多新闻列表
     * @param ob
     */ 
    getMoreNewsList(ob){
        return get('/web/newsInfoEntity/getMoreNewsInfoList',ob)
    },
    /***
     * 获取更多推荐信息信息
     */ 
    getMoreRecommondNews(type){
        return get('/web/newsInfoEntity/getRecommendNewsInfoList?newsType='+type)
    }
}
export default news



// WEBPACK FOOTER //
// ./src/api/modules/news.js